import React from 'react'
import ShareUrl from 'share-url'

const SocialMediaSharing = ({ url, title, twitterHandle = 'joelsaupe', hashtags = [], description, ...rest }) => {
  const twitterUrl = ShareUrl.twitter({
      url,
      text: `Checkout "${title}" on consolelog.io`,
      via: twitterHandle,
      hashtags: hashtags.join(','),
  })

  const linkedinUrl = ShareUrl.linkedin({
    mini: true,
    url,
    title,
    summary: description,
    source: 'consolelog.io'
  })

  const redditUrl = ShareUrl.reddit({
    url,
    title,
  })

  const emailUrl = ShareUrl.email({
    to: '',
    subject: `Checkout "${title}" on consolelog.io`,
    body: `I found this article on consolelog.io that I think you'd really like: ${url}`
  })

  return (
    <div className="notification is-dark has-text-centered is-shadowless" style={{marginTop: '2rem' }} {...rest}>
      <p className="title is-4">before you go, spread the word</p>
      <div className="buttons is-centered">
        <a href={twitterUrl} className="button is-light is-outlined is-medium">
          <span className="icon is-lg">
            <i className="fab fa-twitter fa-lg" />
          </span>
        </a>

        <a href={linkedinUrl} className="button is-light is-outlined is-medium">
          <span className="icon is-lg">
            <i className="fab fa-linkedin fa-lg" />
          </span>
        </a>

        <a href={redditUrl} className="button is-light is-outlined is-medium">
          <span className="icon is-lg">
            <i className="fab fa-reddit fa-lg" />
          </span>
        </a>

        <a href={emailUrl} className="button is-light is-outlined is-medium">
          <span className="icon is-lg">
            <i className="far fa-envelope fa-lg" />
          </span>
        </a>
      </div>
    </div>
  )
}

export default SocialMediaSharing



// WEBPACK FOOTER //
// ./src/components/SocialMediaSharing.jsx